import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const DELETE_AD_UNIT: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation deleteAdUnit($input: DeleteAdUnitInput!) {
    deleteAdUnit(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
